import MainLayout from "../../components/layouts/MainLayout"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { Alert, Spin, Collapse, Card } from "antd"
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { annonceApi } from "../../api/annonceApi";
import { message } from "antd";

import Swal from "sweetalert2"

const { Panel } = Collapse;

const ShowAnnouncement = () =>{
    const {id} = useParams()
    const [annonce, setAnnonce] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()
    const navigate = useNavigate()
    
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
    };
    const date_now = new Date()

    const fetchAnnonce = async () => {
        setLoading(true);
        setError(null);
        try {
          const res = await annonceApi.getAnnouncement(`${id}`,abortController.signal);
          setAnnonce(res.data); // Stocker les données récupérées

          console.log("details",res.data)
        } catch (err) {
          setError("Impossible de charger les détails du mécano.");
        } finally {
          setLoading(false);
        }
      };

    useEffect(() => {       
    
        fetchAnnonce(); // Appeler la fonction immédiatement
    
      }, [id]);

    const handleCheck = async () => {
        setLoading(true);
        setError(null);
          try {
            const res = await annonceApi.checkAnnouncement(`${id}`,abortController.signal);
            // setAnnonce(res.data); // Stocker les données récupérées

            console.log("details",res.data)
            if (!res.success) {
                return Swal.fire({
                title:'Impossible d\'mettre a jour',
                text:res.message,
                // timer:3000
                })
            }
            message.success(res.message)
            fetchAnnonce()
          } catch (err) {
            setError("Impossible de charger les détails du mécano.");
          } finally {
            setLoading(false);
          }
    }

    return <MainLayout>
        <div className="container mx-auto p-6">
        <div className="flex justify-between">
            <h1 className="text-3xl font-semibold mb-6">Détails de l'annonce</h1>
            <Link to={`/annonces`}><LeftCircleOutlined/> Retour  </Link>
        </div>

      {loading && <Spin size="large" />}
      {error && <Alert message={error} type="error" />}
      {!loading && !error && annonce && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Information personnelle */}
          <Collapse defaultActiveKey={['1']} expandIconPosition="start">
            <Panel header="Informations complementaires" key="1" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Titre de l'annonce:</strong> {annonce.title}</p>
                <p><strong>Description :</strong> {annonce?.description || "Non fourni"}</p>
                <p><strong>Pays :</strong> {annonce?.country || "Non fourni"}</p>
                <p><strong>Adresse :</strong> {annonce?.city || "Non fourni"}</p>
                <p><strong>Categorie :</strong> {annonce?.category?.libelle || "Non fourni"}</p>
                <p><strong>Date publication :</strong> {formatDate(annonce?.created_at) || 0}</p>               

                <p><strong>Date expiration :</strong> {formatDate(annonce?.expired_at)}</p>               
                <p><strong>Vues :</strong> {annonce?.views || 0}</p>               
                <p><strong>Likes :</strong> {annonce?.likes || 0}</p>               
                <p><strong>Signaler comme abus :</strong> {annonce?.abus || 0}</p>               
                <p><strong>Annonce mise en avant :</strong> {annonce?.highlighting === 1 ? "OUI" : "NON"}</p>               
                <p><strong>Contact whatsapp de l'annonceur :</strong> {annonce?.whatsapp}</p>               
                <p><strong>Status :</strong> {annonce?.expired_at >= date_now ? <span className="badge bg-green-600 text-white text-sm rounded-md p-1 flex items-center content-center">
                                    Active
                                </span> : <span className="badge bg-red-600  text-white text-sm rounded-md p-1 flex items-center content-center">Expiree</span> }</p>               

              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Auteur de la publication" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom complet :</strong> {annonce?.user?.name + annonce?.user?.lastname }</p>
                <p><strong>Contact :</strong> {annonce?.user?.contact}</p>
                <p><strong>Photo :</strong></p>

              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Images" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <div class="flex ...">
                {
                    annonce.medias?.filter(image => image?.etat === 1)
                    ?.map((image, index) => (
                    <div className="w-32 flex-none ..." key={index}>
                        <img src={image?.file_path} alt={annonce?.title || "Image"} />
                    </div>
                ))}

                    {/* <div class="w-32 flex-none ...">02</div>
                    <div class="flex-1 ...">03</div> */}
                </div>

              </div>
            </Panel>
          </Collapse>
                
            <button onClick={handleCheck} className="p-1 text-md bg-sky-700 mt-2 text-white rounded-sm">{annonce.etat === 1 ? 'Desactiver' : 'Activer'}</button>
                     
        </div>
      )}
    </div>
    </MainLayout>
}

export default ShowAnnouncement